import React from "react";
import { Typography } from "@/components/atoms";
import { clsx } from "@/utils";

export interface DetailFieldProps {
  leading: React.ReactNode;
  label: string | React.ReactNode;
  labelInlineRight?: React.ReactNode;
  value?: React.ReactNode;
  right?: React.ReactNode;
  indent?: boolean;
  className?: string;
  valueClassName?: string;
}

export const DetailField: React.FC<DetailFieldProps> = (props) => {
  const { leading, label, labelInlineRight, value, right, indent = true, className, valueClassName } = props;

  return (
    <div className={clsx("flex items-center gap-2", className)}>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          {leading}
          {typeof label === "string" ? <Typography variant="action">{label}</Typography> : label}
          {labelInlineRight}
        </div>
        <div className={clsx(indent && "pl-8", "min-w-0")}>
          {typeof value === "string" || typeof value === "number" ? (
            <Typography variant="paragraph" className={clsx(valueClassName)}>
              {value}
            </Typography>
          ) : (
            <div className={clsx(valueClassName)}>{value}</div>
          )}
        </div>
      </div>
      {right && <div className="flex items-center">{right}</div>}
    </div>
  );
};

DetailField.displayName = "DetailField";
